var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4326 34.9278L29.8001 28.7177V19.0862C29.8001 12.7621 25.0214 7.55604 18.8784 6.87663V3.83055C18.8784 3.07657 18.2671 2.46533 17.5132 2.46533C16.7592 2.46533 16.1479 3.07657 16.1479 3.83055V6.87663C10.0049 7.55607 5.22619 12.7621 5.22619 19.0862V28.7177L0.593704 34.9278C-0.864937 36.8833 0.530551 39.6652 2.97007 39.6652H32.0562C34.4957 39.6652 35.8912 36.8833 34.4326 34.9278Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8311 41.65H19.1954C21.0265 41.65 22.511 40.1656 22.511 38.3345H12.5156C12.5156 40.1656 14 41.65 15.8311 41.65Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5137,
    cy: 9.5,
    r: 9.5,
    fill: "#F35929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4817 12.356C28.7537 12.14 28.8777 12.04 28.8537 12.056C29.6377 11.408 30.2537 10.876 30.7017 10.46C31.1577 10.044 31.5417 9.608 31.8537 9.152C32.1657 8.696 32.3217 8.252 32.3217 7.82C32.3217 7.492 32.2457 7.236 32.0937 7.052C31.9417 6.868 31.7137 6.776 31.4097 6.776C31.1057 6.776 30.8657 6.892 30.6897 7.124C30.5217 7.348 30.4377 7.668 30.4377 8.084H28.4577C28.4737 7.404 28.6177 6.836 28.8897 6.38C29.1697 5.924 29.5337 5.588 29.9817 5.372C30.4377 5.156 30.9417 5.048 31.4937 5.048C32.4457 5.048 33.1617 5.292 33.6417 5.78C34.1297 6.268 34.3737 6.904 34.3737 7.688C34.3737 8.544 34.0817 9.34 33.4977 10.076C32.9137 10.804 32.1697 11.516 31.2657 12.212H34.5057V13.88H28.4817V12.356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.ae8a2f2904826a15f8cd735e44dcb89c.svg";
export { ForwardRef as ReactComponent };